import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../../../../utils/tpoGenQueryKeys';

export interface ObjectiveOptionRaw {
    label: string;
    value: string;
    disabled: boolean;
    constraint_value: string;
    constraint_label: string;
}

export interface ObjectiveOptionType {
    label: string;
    value: string;
    disabled: boolean;
    constraintKey: string;
    constraint_label: string;
}

const mapOption = (option: ObjectiveOptionRaw): ObjectiveOptionType => ({
    label: option.label,
    value: option.value,
    disabled: option.disabled,
    constraintKey: option.constraint_value,
    constraint_label: option.constraint_label,
});

export const useObjectiveOptions = (enabled = true) => {
    const {
        data: objectiveList,
        isLoading: objectiveListLoading,
        error,
    } = useQuery({
        queryKey: tpoGenKeys.objectiveOptions(),
        queryFn: async (): Promise<ObjectiveOptionType[]> => {
            const response = await axios(tpoGenUrls.getDefaultObjectives, { method: 'GET' });
            return (response.data as ObjectiveOptionRaw[]).map(mapOption);
        },
        enabled,
        retry: 3,
        retryDelay: (attemptIndex) => Math.min(1000 * Math.pow(2, attemptIndex), 5000),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });

    return {
        objectiveList: objectiveList ?? [],
        objectiveListLoading,
        error,
    };
};
